import { Contact } from "./Contact";

import { Address } from "./Address";
export class Waiter {
  constructor() {
    this.id =""
    this.name = "";
    (this.address = new Address()), 
    (this.contact = new Contact());
    (this.remarks = "");
   
  }

  //get Api data and Deserialise the data
  initialise(initialiser) {
    
    const data = new Waiter();
    data.name = initialiser.name ? initialiser.name : "";
    data.remarks = initialiser.remarks ? initialiser.remarks : "";

    if (initialiser && initialiser.address) {
      data.address = initialiser.address
    //     ? new Address().initialise(initialiser.address)
    //     : "";
    // } else {
    //   data.address = new Address();
    }
    if (initialiser.contact) {
      // const contacts=JSON.parse(initialiser.contacts)
      data.contact = initialiser.contact
    } 
    return data;
  }
  // ToRequestModel(data) {
  //   data.addresses.push(data.address);
  //   data.contracts.push(data.contacts);
  //   return data;
  // }

  ToRequestModel(initialiser) {
    
    const data = new Waiter();
    data.id = initialiser.id ? initialiser.id : "";
    data.name = initialiser.name ? initialiser.name : "";
    data.remarks = initialiser.remarks ? initialiser.remarks : "";

    if (initialiser && initialiser.address) {
      data.address = initialiser.address
    }
    if (initialiser.contact) {
      data.contact = initialiser.contact
    } 
    return data;
  }
}
